"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { fetchMoreComments } from "@/app/[domain]/(sites)/_actions/comments/fetch-more-comments";
import { RegularButton } from "@/components/Button/RegularButton/RegularButton.component";
import { useComments } from "@/components/Comment/context/comments.context";
import { useCommentsActions } from "@/components/Comment/hooks/use-comment-actions.hook";
import { Translation } from "@/components/Translation/Translation.component";
import { captureClientException } from "@/services/logging/capture-client-exception";
import { hasFailed, hasSucceeded } from "@/services/utilities/fetchable";
type LoadState = "idle" | "loading";
export function LoadMoreCommentsButton() {
  const $ = _c(12);
  const {
    storyId,
    state: t0
  } = useComments();
  const {
    pagination
  } = t0;
  const {
    appendComments
  } = useCommentsActions();
  const [loadState, setLoadState] = useState("idle");
  let t1;
  if ($[0] !== appendComments || $[1] !== loadState || $[2] !== pagination.endCursor || $[3] !== storyId) {
    t1 = async () => {
      if (!pagination.endCursor || loadState === "loading") {
        return;
      }
      setLoadState("loading");
      const result = await fetchMoreComments({
        articleId: storyId,
        cursor: pagination.endCursor,
        limit: 2
      });
      if (hasSucceeded(result)) {
        appendComments(result.value);
      }
      if (hasFailed(result)) {
        captureClientException(new Error("Failed to load more comments"), {
          extra: {
            articleId: storyId,
            cursor: pagination.endCursor
          }
        });
      }
      setLoadState("idle");
    };
    $[0] = appendComments;
    $[1] = loadState;
    $[2] = pagination.endCursor;
    $[3] = storyId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleLoadMore = t1;
  const t2 = loadState === "loading";
  const t3 = loadState === "loading";
  let t4;
  if ($[5] !== loadState) {
    t4 = loadState === "loading" ? <Translation da={"Indl\xE6ser..."} de="Laden..." en="Loading..." no="Laster..." sv="Laddar..." /> : <Translation da={"Indl\xE6s flere kommentarer"} de="Mehr Kommentare laden" en="Load more comments" no="Last flere kommentarer" sv="Ladda fler kommentarer" />;
    $[5] = loadState;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleLoadMore || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex flex-col items-center gap-2"><RegularButton aria-busy={t2} disabled={t3} onClick={handleLoadMore} type="button">{t4}</RegularButton></div>;
    $[7] = handleLoadMore;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}